module.exports = __webpack_public_path__ + "img/item_Story_03.0c6f2c83.jpeg";